<template>
  <v-app id="application" class="w-full overflow-hidden">
    <v-app-bar
      elevation="8"
      app
      dark
      fixed
      clipped-left
      class="relative w-full overflow-hidden"
      prominent
      :dense="$vuetify.breakpoint.mobile ? true : false"
      color="primary"
      :shrink-on-scroll="!$vuetify.breakpoint.mobile"
      :src="$connection + '/images/tgs.jpg'"
    >
      <template v-slot:img="{ props }">
        <v-img
          cover
          v-bind="props"
          gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
        ></v-img>
      </template>
      <TgsToolbar
        :class="$vuetify.breakpoint.xl ? 'container py-0 my-0' : ''"
        @toggel-drawer="drawer = $event"
        :drawer="drawer"
        :navigation="navigation"
        :navigations="navigations"
      />
    </v-app-bar>
    <v-navigation-drawer
      :style="`margin-top: ${$vuetify.application.top}px`"
      app
      fixed
      temporary
      right
      v-model="drawer"
    >
      <SidebarContent />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="$route.path.includes('abteilung/') && !$vuetify.breakpoint.mobile"
      app
      permanent
      clipped
      fixed
      height="100%"
    >
      <v-list dense>
        <div></div>
        <NavbarListItem
          :text="department.title"
          :selector="department.selector"
        />
        <v-divider></v-divider>
        <NavbarListItem
          v-for="(course, i) in department.courses"
          :key="i"
          :text="course.title"
          :selector="course.selector"
          accent
        />
        <v-divider></v-divider>
        <NavbarListItem text="Berichte der Abteilung" selector="#blogposts" />
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="
        $route.path.includes('workshop') &&
        !$route.path.includes('account') &&
        !$vuetify.breakpoint.mobile
      "
      app
      permanent
      clipped
      fixed
      height="100%"
    >
      <v-list dense>
        <div></div>
        <NavbarListItem :text="$t('workshops')" selector="#workshops" />
        <v-divider></v-divider>
        <NavbarListItem
          v-for="(course, i) in workshops"
          :key="i"
          :text="course.title"
          :selector="course.selector"
          accent
        />
        <v-divider></v-divider>
        <NavbarListItem text="Berichte der Workshops" selector="#blogposts" />
      </v-list>
    </v-navigation-drawer>
    <NavigationDrawer v-if="!$vuetify.breakpoint.mobile" />
    <v-main name="main" app style="background-color: #f5f7fa !important">
      <v-scroll-y-transition mode="in-out" hide-on-leave>
        <router-view></router-view>
      </v-scroll-y-transition>
    </v-main>

    <flash></flash>

    <v-bottom-sheet
      v-model="sheet"
      v-if="$vuetify.breakpoint.mobile && user.email"
      style="border-top-right-radius: 25px; border-top-left-radius: 25px"
      class="overflow-hidden"
    >
      <v-list
        style="border-top-right-radius: 25px; border-top-left-radius: 25px"
        class="overflow-hidden elevation-20"
      >
        <template v-for="(val, key, i) in items">
          <v-list-item
            v-if="show(key)"
            :key="i"
            @click="sheet = false"
            link
            exact
            :to="{ name: items[key].title }"
          >
            <v-list-item-avatar>
              <v-avatar size="32px" tile>
                <v-icon>{{ config.icons[key].icon }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title>{{
              $t(items[key].translation)
            }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-bottom-sheet>

    <SettingsDial v-if="false" />

    <ScrollToTopButton />

    <div class="text-center" v-if="banner && !$route.path.includes('account')">
      <v-bottom-sheet inset v-model="banner" hide-overlay persistent>
        <v-sheet class="text-center px-5 pt-5" height="auto">
          <div class=" mx-auto max-w-4xl" :class="$vuetify.breakpoint.smAndDown ? '':'d-flex' ">
            <v-btn icon text class="mr-2 mt-2" color="primary">
              <v-icon large color="amber accent-4"
                >mdi-cookie-alert-outline</v-icon
              >
            </v-btn>
            <div class="mb-3 mt-2">
              Wir verwenden auf dieser Webseite für optimalen Komfort und zur
              Nutzungsanalyse s.g. Cookies! Sollten Sie damit nicht
              einverstanden sein, verlassen Sie bitte diese Webseite.
              Anderenfalls bestätigen Sie mit einem Klick auf Einverstanden.
            </div>
          </div>

          <div class="d-flex justify-center pb-10">
            <v-btn
              class="mt-6 text-capitalize"
              text
              color="primary"
              :to="{ name: 'Privacy', params: { lang: 'de' } }"
              >Datenschutz</v-btn
            >
            <div class="w-10"></div>
            <v-btn
              class="mt-6 text-capitalize"
              dark
              color="green"
              @click="banner = false"
              >Einverstanden</v-btn
            >
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>

    <v-footer
      dense
      app
      dark
      class="pa-0 w-full overflow-hidden"
      padless
      v-touch="{ up: () => swipe() }"
      fixed
    >
      <v-card
        flat
        @click="sheet = true"
        tile
        class="primary white--text text-center pa-0 ma-0 w-full"
      >
        <small class="white--text pa-0">
          Copyright © {{ new Date().getFullYear() }} —
          <strong>Turngemeinde Schwalbach 1887 e.V.</strong>
          <span v-if="!$vuetify.breakpoint.mobile">
            {{ $t("footer.legal") }}.
            <!-- {{ $t("footer.designed_by") }} Gianni Pasqual. -->
          </span>
        </small>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import SettingsDial from "@/components/SettingsDial";
import TgsToolbar from "@/components/TgsToolbar";
import NavbarListItem from "@/components/NavbarListItem";
import ScrollToTopButton from "@/components/small/ScrollToTopButton";
import NavigationDrawer from "@/components/NavigationDrawer";
import SidebarContent from "@/components/SidebarContent";
export default {
  name: "App",
  components: {
    SidebarContent,
    NavigationDrawer,
    SettingsDial,
    NavbarListItem,
    TgsToolbar,
    ScrollToTopButton,
  },
  data: () => ({
    sheet: false,
    drawer: false,
    banner: true,
    navigation: [
      { translation: "nav.start", name: "Home" },
      { translation: "nav.blog", name: "Blog" },
      {
        translation: "nav.departments",
        name: "Abteilungen",
        dropdown: true,
        departments: [],
      },
      {
        translation: "nav.workshops",
        name: "Workshops",
        dropdown: true,
        workshops: [],
      },
      { translation: "nav.run", name: "Volkslauf", info: true },
    ],
    navigations: [
      { translation: "nav.formulars", name: "Formulare" },
      // { translation: "nav.contact", name: "Kontakt" },
      { translation: "nav.locations", name: "Locations" },
      { translation: "nav.dashboard", name: "Dashboard" },
    ],
    items: {
      dashboard: { translation: "nav.dashboard", title: "Dashboard" },
      department: {
        translation: "nav.departments",
        title: "Account_Department",
      },
      course: { translation: "nav.courses", title: "Account_Course" },
      workshop: { translation: "nav.workshops", title: "Account_Workshop" },
      blog: { translation: "nav.blog", title: "Account_Post" },
      news: { translation: "nav.news", title: "News" },
      sponsor: { translation: "nav.sponsor", title: "Sponsors" },
      location: { translation: "nav.location", title: "AccountLocations" },
      profile: { translation: "nav.profile", title: "Profile" },
    },
  }),
  computed: {
    department() {
      return this.$store.getters["department/getCurrentDepartment"];
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    departments() {
      return this.$store.getters["publicApi/getDepartments"];
    },
    workshops() {
      return this.$store.getters["publicApi/getWorkshops"];
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
  },
  methods: {
    swipe() {
      this.sheet = true;
    },
    disableTracking() {
      this.$ga.disable();
    },
    show(key) {
      let show = true;
      switch (key) {
        case "dashboard":
          show = Array.of("admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "department":
          show = Array.of("admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "course":
          show = Array.of("course", "admin", "owner", "department").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "workshop":
          show = Array.of("workshop", "admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "blog":
          show = Array.of(
            "course",
            "department",
            "workshop",
            "admin",
            "owner"
          ).some((x) => this.user.roles.includes(x));
          break;
        case "news":
          show = Array.of(
            "course",
            "department",
            "workshop",
            "admin",
            "owner"
          ).some((x) => this.user.roles.includes(x));
          break;
        case "banners":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "support":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "sponsor":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        case "locations":
          show = Array.of("admin", "owner").some((x) =>
            this.user.roles.includes(x)
          );
          break;
        default:
          break;
      }
      return show;
    },
  },

  async created() {
    await this.$store.dispatch("config/getConfig");
    this.$store.dispatch("publicApi/getDepartments");
    this.$store.dispatch("publicApi/getWorkshops");
    this.$store.dispatch("user/verification");
  },
};

// Icons erstellt von <a href="http://www.freepik.com/" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/de/" title="Flaticon"> www.flaticon.com</a>
// Icons erstellt von <a href="https://www.flaticon.com/de/autoren/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/de/" title="Flaticon"> www.flaticon.com</a>
// Icons erstellt von <a href="https://www.flaticon.com/de/autoren/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/de/" title="Flaticon"> www.flaticon.com</a>
// https://www.flaticon.com/de/kostenloses-icon/spanien_555635
</script>

<style type="scss">
@import "./styles/main.scss";
@import "./assets/main.scss";


.v-toolbar__content {
  padding: 0px 0px !important;
}

.active::before {
  content: "";
  background-color: white !important;
  position: absolute;
  height: 8px;
  bottom: 0;
  z-index: 100;
  right: 0;
  margin-top: auto;
  border-radius: 9999px;
}
* {
  box-sizing: border-box;
}
</style>
